import { AuthenticationState } from "../models/authenticationState";

export class AuthenticationError extends Error {
    constructor(public state: AuthenticationState) {
        super(`AuthenticationError-${state}`);
    }
}
